import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import Navbar from "../../../../Shared/ManagerNavbar/Navbar";
import baseURL from "../../../../Apiurs/Apiurls";
import { FiEye } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const ViewSentQuotations = () => {
  const { leadId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { leadInfo } = location.state || {};

  const [quotations, setQuotations] = useState([]);
  const [collapsed, setCollapsed] = useState(false);
  const [message, setMessage] = useState("");
  const [expandedRows, setExpandedRows] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchQuotations = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${baseURL}/api/allquotations/${leadId}`);
        const data = await res.json();
        console.log("API Response:", data);

        let quotationsData = [];

        // Handle different response structures
        if (data.success && data.data) {
          quotationsData = Array.isArray(data.data) ? data.data : [data.data];
        } else if (Array.isArray(data)) {
          quotationsData = data;
        } else if (data && typeof data === "object" && Object.keys(data).length > 0) {
          quotationsData = [data];
        }

        // Check if we have valid quotation data with products
        const hasValidQuotations = quotationsData.some(q => 
          q && (q.products || q.quotation_number || q.id)
        );

        if (hasValidQuotations && quotationsData.length > 0) {
          const parsed = quotationsData.map((q) => ({
            ...q,
            products:
              typeof q.products === "string"
                ? JSON.parse(q.products)
                : q.products || [],
          }));
          setQuotations(parsed);
          setMessage("");
        } else {
          setQuotations([]);
          setMessage("No quotation data found for this lead.");
        }
      } catch (err) {
        console.error("Error fetching quotations:", err);
        setMessage("Error fetching quotations");
        setQuotations([]);
      } finally {
        setLoading(false);
      }
    };

    fetchQuotations();
  }, [leadId]);

  const toggleExpand = (quotationId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [quotationId]: !prev[quotationId],
    }));
  };

  // ✅ Handle PDF view correctly (new backend path support)
  const handleViewPDF = (quotation) => {
    if (!quotation.quotation_pdf) {
      alert("No PDF available for this quotation");
      return;
    }

    let pdfPath = quotation.quotation_pdf;

    // If the stored path doesn't start with /Uploads, fix it
    if (!pdfPath.startsWith("/Uploads")) {
      pdfPath = `/Uploads${pdfPath.startsWith("/") ? "" : "/"}${pdfPath}`;
    }

    const pdfUrl = `${baseURL}${pdfPath}`;
    console.log("Opening PDF:", pdfUrl);

    // Open the PDF in new tab
    window.open(pdfUrl, "_blank");
  };

  // Check if we should show "no data" message
  const shouldShowNoData = !loading && (quotations.length === 0 || message.includes("No quotation"));

  return (
    <div className="AdminLeadscontainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`AdminLeads ${collapsed ? "collapsed" : ""}`}>
        <div className="container-fluid mt-4 mb-5">
          <div className="card shadow-lg border-0 rounded-3">
            <div className="card-body">
              <h3 className="mb-4 fw-bold text-dark">
                Sent Quotations{" "}
                <span className="text-primary fw-semibold">
                  {leadInfo?.name
                    ? `for ${leadInfo.name}`
                    : `for Lead ID #${leadId}`}
                </span>
              </h3>

              {loading && (
                <div className="alert alert-info">
                  Loading quotations...
                </div>
              )}

              {/* {message && (
                <div
                  className={`alert ${
                    message.includes("Failed") || 
                    message.includes("Error") || 
                    message.includes("No quotation")
                      ? "alert-info"
                      : "alert-success"
                  }`}
                >
                  {message}
                </div>
              )} */}

              {shouldShowNoData ? (
                <div className="alert alert-info text-center py-4">
                  <h5 className="mb-3">No Quotation Data Found</h5>
                  <p className="mb-0">
                    No quotation data found for Lead ID #{leadId}
                  </p>
                </div>
              ) : quotations.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-bordered align-middle table-hover shadow-sm">
                    <thead className="table-primary text-dark">
                      <tr>
                        <th style={{ width: "50px" }}></th>
                        <th>Quotation No</th>
                        <th>Date</th>
                        <th>Subtotal</th>
                        <th>Discount</th>
                        <th>GST</th>
                        <th>Total</th>
                        <th>View PDF</th>
                      </tr>
                    </thead>
                    <tbody>
                      {quotations.map((row) => (
                        <React.Fragment key={row.id}>
                          <tr className="bg-light">
                            <td>
                              <button
                                className="btn btn-sm btn-outline-primary rounded-circle"
                                onClick={() => toggleExpand(row.id)}
                                title={
                                  expandedRows[row.id]
                                    ? "Collapse"
                                    : "Expand"
                                }
                              >
                                {expandedRows[row.id] ? "−" : "+"}
                              </button>
                            </td>
                            <td className="fw-semibold text-dark">
                              {row.quotation_number || "N/A"}
                            </td>
                            <td>
                              {row.quotation_date ? 
                                new Date(row.quotation_date).toLocaleDateString("en-IN") : 
                                "Invalid Date"
                              }
                            </td>
                            <td className="text-success fw-semibold">
                              ₹{row.subtotal || "0"}
                            </td>
                            <td className="text-success fw-semibold">
                              {row.discount || "0"} {row.discountType || ""}
                            </td>
                            <td className="text-warning">₹{row.gst || "0"}</td>
                            <td className="fw-bold text-dark">
                              ₹{row.total_amount || "0"}
                            </td>
                            <td>
                              <button
                                className="btn btn-sm btn-outline-info shadow-sm"
                                onClick={() => handleViewPDF(row)}
                                title="View PDF"
                                disabled={!row.quotation_pdf}
                              >
                                <FiEye />
                              </button>
                            </td>
                          </tr>

                          {expandedRows[row.id] &&
                            row.products &&
                            Array.isArray(row.products) &&
                            row.products.length > 0 && (
                              <tr>
                                <td colSpan="9" className="p-0">
                                  <div className="table-responsive">
                                    <table className="table table-sm table-striped table-bordered mb-0">
                                      <thead className="table-light">
                                        <tr>
                                          <th>Product</th>
                                          <th>Batch</th>
                                          <th>Size</th>
                                          <th>HSN Code</th>
                                          <th>GST %</th>
                                          <th>Price</th>
                                          <th>MOQ</th>
                                          <th>Quantity</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {row.products.map((p, idx) => (
                                          <tr key={idx}>
                                            <td className="fw-semibold text-dark">
                                              {p.maincategory_name} <br />
                                              {p.subcategory_name} <br />
                                              {p.product_name} - {p.batch}{" "}
                                              <br />
                                              <small className="text-muted">
                                                Size: {p.size}
                                              </small>
                                            </td>
                                            <td>{p.batch}</td>
                                            <td>{p.size}</td>
                                            <td>{p.hsncode}</td>
                                            <td>{p.gstrate}%</td>
                                            <td className="text-success">
                                              ₹{p.listprice}
                                            </td>
                                            <td>{p.moq}</td>
                                            <td>{p.quantity}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </td>
                              </tr>
                            )}
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


export default ViewSentQuotations;
